import { render, staticRenderFns } from "./order.vue?vue&type=template&id=465eab7d&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=465eab7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465eab7d",
  null
  
)

/* custom blocks */
import block0 from "@/common/i18n/i18n-locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fsean%2Fprojects%2Fezmeals%2Fezmeals-order-ui%2Fsrc%2Fpages%2Forder.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./order.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports